module.exports = __webpack_public_path__ + "static/media/old baker-steel-gold.9f018790.csv";